import React from "react";
import Enrolment from "../Enrolment";

const EnrolledWaitingResultComponent = () => {
  return <Enrolment title="waiting for result" status="waiting-for-result" />;
};

export default EnrolledWaitingResultComponent;
